<template>
  <div v-show="showHubspotPicker" class="hubspot-filepicker" @on-filepicker-close="close">
    <click-outside :handler="close" id="hubspot-filepicker-co" class="fp-popup" style="width: 80%; max-height: 91%;">
      <FilePickerHeader :logo="logo" connector="hubspot" :key="'hubspot'" :user="user" :domain="domain"
                        v-on:close-filepicker="close"/>
      <div class="filepicker-selector-container">
        <div style="display: inline-flex; width: 100%;" v-if="items.length">
          <div class="filepicker-input-item">
            <div class="bold">Select Type</div>
            <v-select
                :options="items"
                v-model="selectedItem"
                class="v-select-styling"
                label="label"
                @input="loadSubItems"
            ></v-select>
          </div>
          <div class="filepicker-input-item">
            <div class="bold">Sort By</div>
            <v-select :options="sortOptions"
                      label="label"
                      v-model="sortBy"
                      class="v-select-styling"
                      @input="selectSortBy"></v-select>
          </div>
        </div>
      </div>
      <div>
        <div class="picker-subheader">
          <div class="picker-subheader-text flex">
            <div>
              Select Files
              <span v-if="fileCount > 0">&nbsp;({{ fileCount }})</span>
            </div>
          </div>
          <div class="picker-subheader-selected-text">
            <div>
              Selected Files
              <span v-if="selectedFileCount > 0">&nbsp;({{ selectedFileCount }})</span>
            </div>
          </div>
        </div>
      </div>
      <div class="filepicker-body">
        <div v-if="fileCount > 0">
          <div class="picker-search-container">
            <div class="picker-subheader-text flex">
              <input class="search-bar-input" v-model="searchTerm" placeholder="Search..."/>
            </div>
          </div>
        </div>
        <div class="file-tree">
          <div>
            <div class="all-files">
              <div class="file-picker-tree">
                <div v-if="loadingFiles">
                  Loading...
                </div>
                <div v-else>
                  <div
                      class="selected-file"
                      style="display: block"
                      v-for="(file, k) in filteredFiles"
                      :key="file.id"
                  >
                    <div class="artt-cursor">
                  <span
                      class="article-name artt-cursor"
                      @click="fileSelected(file)"
                      :title="files.name"
                      :id="file.id + '-file-un-selected'"
                  >{{ file.name }}</span>
                      <a :href="file.absolute_url" target="_blank">
                        <img src="/images/open-new-tab.png" title="Open in new tab" style="width: 10px"/>
                      </a>
                    </div>
                    <div v-if="file.translations" class="flex">
                      <div>
                        <button
                            class="locale-pill"
                            @click.prevent
                            disabled
                            v-if="file.language"
                        >{{ file.language }}
                        </button>
                        <span v-if="file.translations.length > 0">➤</span>
                      </div>
                      <div v-for="translation in file.translations" :key="translation.language">
                        <button
                            class="locale-pill"
                            @click.prevent
                            disabled
                        >{{ translation.language }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="selected-files">
          <div class="file-picker-tree">
            <div
                class="selected-file"
                style="list-style: none"
                v-for="(file, k) in selectedFiles"
                :key="k"
            >
              <div class="article-name" :title="file.name">{{ file.name }}</div>
              <div>
                <a
                    @click="fileDeselected($event, file, k)"
                    type="button"
                    style="cursor: pointer"
                >&nbsp;x</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="picker-footer-links" v-if="this.fileCount > 0 || this.selectedFileCount > 0">
        <div class="picker-subheader-text flex">
          <a
              v-if="this.fileCount > 0"
              title="Select all"
              class="picker-footer-link"
              @click.prevent="selectAllFiles">
            Select All
          </a>
          <a
              title="Select all pages/blogs with out of date translated versions"
              v-if="this.fileCount > 0"
              class="picker-footer-link"
              @click.prevent="outOfDateTranslations">
            Select Outdated
          </a>
          <a
              v-if="this.fileCount > 0"
              title="Select all untranslated files"
              class="picker-footer-link"
              @click.prevent="missingFiles">
            Select Untranslated
          </a>
        </div>
        <div class="picker-footer-links-selected-text">
          <a
              title="Deselect all"
              v-if="this.selectedFileCount > 0"
              class="picker-footer-link"
              @click.prevent="deselectAllFiles">
            Clear
            Selection
          </a>
        </div>
      </div>
      <div class="filepicker-footer">
        <button class="cancel-btn" id="hubspot-cancel" @click.prevent="cancel">Cancel
        </button>
        <button
            class="filepicker-bt"
            id="hubspot-upload-files"
            :class="submitButtonClass"
            @click.prevent="upload"
        >{{ submitButtonText }}
        </button>
      </div>
    </click-outside>
    <div class="fp-mask" :style="{ display: showHubspotPicker ? 'block' : 'none' }"></div>
  </div>
</template>

<script>
import "../style.scss";
import ClickOutside from "onclick-outside";
import axios from "axios";
import {reject} from "lodash";
import FilePickerHeader from "../FilePickerHeader";
import {mapGetters, mapState} from "vuex";
import {EventBus} from "../../../../event-bus";

// TODO break into components

let CancelRequest = null;
let $token = $("#token");

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

if ($token.length) {
  axios.defaults.headers.common["X-CSRF-TOKEN"] = $token.attr("content");
}
else {
  console.error(
      "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
  );
}

export default {
  name: "hubspotFilePicker",
  props: ["logo"],
  data () {
    return {
      showHubspotPicker: false,
      loadingFiles: false,
      loadedOnce: false,
      files: [],
      searchTerm: "",
      filePage: 1,
      filePageCount: 1,
      user: undefined,
      orderId: undefined,
      domain: undefined,
      selectedFiles: [],
      items: [
        {
          label: "Blog Posts",
          id: "blogs"
        },
        {
          label: "Website Pages",
          id: "site_page"
        },
        {
          label: "Landing Pages",
          id: "landing_page"
        },
        {
          label: "Marketing Emails",
          id: "emails"
        }
      ],
      selectedItem: undefined,
      showPreview: false,
      previewContent: "",
      loadResult: "Loading...",
      submitButtonText: "Upload Files",
      sortBy: {
        label: 'Name',
        name: 'name'
      },
      sortOptions: [
        {
          label: 'Name',
          name: 'name'
        },
        {
          label: 'Last Updated',
          name: 'updated'
        },
        {
          label: 'Created At',
          name: 'created'
        },
      ],
    };
  },
  components: {
    FilePickerHeader,
    "click-outside": ClickOutside
  },
  watch: {
    showHubspotPicker: function (val, oldVal) {
    }
  },
  mounted () {
    EventBus.$on("show-hubspot-picker", data => {
      this.showHubspotPicker = true;
      this.orderId = data?.orderId;
      if (!this.user && !this.loadedOnce) {
        axios.get(`/connectors/hubspot/picker/user`)
            .then(response => {
              if (!response.data.success) {
                return;
              }
              this.user = response.data.email;
              this.domain = response.data.domain;
            }).catch(function (error) {
        });
      }
      this.loadedOnce = true;
    });
  },
  computed: {
    //counters
    ...mapState({
      uploadFileType: state => state.CreateOrderStore.orderDetails.uploadFileType,
      features: state => state.store.features,
    }),
    ...mapGetters('FeatureFlagStore', {
      'getFeature': 'getFeatureStatusByName'
    }),
    fileCount () {
      return this.files.length;
    },
    selectedFileCount () {
      return this.selectedFiles.length;
    },
    //computed bound classes
    submitButtonClass: function () {
      return {
        'disabled-btn': this.selectedFileCount === 0,
        'bbutton': this.selectedFileCount > 0
      };
    },
    multiSelectButtonClass: function () {
      return {
        "hubspot-bt-disabled": this.fileCount === 0,
        "hubspot-bt-secondary": this.fileCount > 0
      };
    },
    multiSelectLinkClass: function () {
      return {
        "picker-footer-link": this.fileCount > 0,
        "picker-footer-link-disabled": this.fileCount === 0
      };
    },
    filteredFiles: function () {
      if (this.searchTerm === '') {
        return this.files;
      }

      let term = this.searchTerm;
      let filtered = [];

      for (const [key, value] of Object.entries(this.files)) {
        if (value.name.toLowerCase().includes(term.toLowerCase())) {
          filtered.push(value);
        }
      }

      return filtered;

    }
  },
  methods: {
    loadSubItems () {
      if (!this.selectedItem) {
        return;
      }
      this.loadingFiles = true;

      axios
          .get(`/connectors/hubspot/picker/items/${this.selectedItem.id}?sort_by=${this.sortBy.name}`)
          .then(response => {
            this.files = response.data.objects;
            this.loadingFiles = false;
          })
          .catch(function (error) {
            this.loadingFiles = false;
          });
    },
    fileSelected (file) {
      this.fileInSelected(file) ? this.selectedFiles.push(file) : false;
    },
    fileDeselected (index, file, k) {
      this.selectedFiles = reject(this.selectedFiles, function (f) {
        return f.id === file.id;
      });
      file.selected = false;
    },
    selectAllFiles () {
      for (const [key, file] of Object.entries(this.filteredFiles)) {
        this.fileInSelected(file) ? this.selectedFiles.push(file) : false;
      }
    },
    deselectAllFiles () {
      this.selectedFiles.forEach((art, i) => {
        let id = art.id;
        art.selected = false;
      });
      this.selectedFiles = [];
    },
    fileExistsInSelectedFile (file) {
      return this.selectedFiles.some(art => art.id === file.id);
    },
    fileInSelected (file) {
      return this.selectedFiles.indexOf(file) === -1;
    },
    missingFiles () {

      let hasMissing = false;

      // get all articles that don't have translations
      for (const [i, file] of Object.entries(this.filteredFiles)) {
        if (!this.fileExistsInSelectedFile(file)) {
          // no translations
          if (!file.translations || !file.translations.length) {
            hasMissing = true;
            this.fileSelected(file);
          }
        }
      }

      if (!hasMissing) {
        alert("No articles with missing translations...");
      }

    },
    outOfDateTranslations () {

      let hasOutOfDate = false;

      // for each article
      for (const [i, file] of Object.entries(this.filteredFiles)) {
        // if the article doesn't exist already
        if (file.translations && !this.fileExistsInSelectedFile(file)) {
          file.translations.forEach((translation, i) => {
            if (translation.outdated) {
              this.fileSelected(file);
              hasOutOfDate = true;
            }
          });
        }
      }

      if (!hasOutOfDate) {
        alert("No out of date translations...");
      }
    },
    upload () {
      if (this.selectedFileCount === 0) {
        return;
      }
      this.submitButtonText = "Loading...";

      let orderId = this.orderId;

      if (!orderId) {
        orderId =
            $("#order_id").val() === undefined ? 0 : $("#order_id").val();
      }

      let payload = [];
      for (const [key, value] of Object.entries(this.selectedFiles)) {
        payload.push({
          'id': value.id,
          'analytics_page_type': value.analytics_page_type
        });
      }

      let fileType = this.uploadFileType;

      $.ajax({
        url: "/connectors/hubspot/picker/upload",
        data: {
          objects: payload,
          orderId: orderId,
          type: fileType
        },
        method: "post",
        success: d => {
          this.submitButtonText = "Upload Files";

          //let any listeners know about the new file
          EventBus.$emit('file-uploaded');

          this.close();
        },
        error: e => {
          this.submitButtonText = "Upload Files";
          alert(
              "Oops.. something went wrong, please let us know about this..."
          );
        }
      });
    },
    selectSortBy (sortByOption) {

      this.loadSubItems();

    },

    // cleanup functions
    close () {
      if (!this.showHubspotPicker) return;
      this.clearAllTheThings();
      this.showHubspotPicker = false;
    },
    cancel (e) {
      this.clearAllTheThings();
      this.showHubspotPicker = false;
    },
    //initiate shutdown sequence
    clearAllTheThings () {
      this.deselectAllFiles();
      this.files = {};
      this.selectedFiles = [];
      this.selectedItem = undefined;
      this.filePageCount = 1;
      this.errored = false;
      this.searchTerm = '';
    }
  }
};
</script>
